import { render, staticRenderFns } from "./PublicationPreview.vue?vue&type=template&id=42e43d37&scoped=true"
import script from "./PublicationPreview.vue?vue&type=script&lang=js"
export * from "./PublicationPreview.vue?vue&type=script&lang=js"
import style0 from "./PublicationPreview.vue?vue&type=style&index=0&id=42e43d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e43d37",
  null
  
)

export default component.exports